import { Chip } from '@mui/material';
import React from 'react';
import { multiChipStyles } from './NewChip';

export const PendingChip = ({
  label,
  selected,
  chipIndex,
}: {
  label: string;
  selected?: number;
  chipIndex?: number;
}) => {
  const { classes } = multiChipStyles();
  chipIndex = chipIndex + 1;
  return (
    <React.Fragment>
      <Chip
        label={label}
        variant="outlined"
        className={classes.chip}
        style={{
          color: '#FC9508',
          backgroundColor: '#FFF4E5',
          border: '2px solid #FC9508',
          paddingRight: selected > chipIndex ? '69px' : '',
          paddingLeft: chipIndex > selected ? '69px' : '',
        }}
      />
    </React.Fragment>
  );
};
